import Vue from 'vue';
import App from './App.vue';
import router from './router/routes';
import * as VueGoogleMaps from 'vue2-google-maps';
import vClickOutside from 'v-click-outside';
import './vee-validate';
import { BProgress, BProgressBar } from 'bootstrap-vue';
import VueScrollingUl from "vue-scrolling-ul";
Vue.component('b-progress', BProgress);
Vue.component('b-progress-bar', BProgressBar);

Vue.config.productionTip = false;

console.log(process.env.VUE_APP_GOOGLE_API_KEY);

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_API_KEY,
        libraries: 'places', // This is required if you use the Autocomplete plugin
    },
});
Vue.use(vClickOutside);
Vue.use(VueScrollingUl);

new Vue({
    render: (h) => h(App),
    router,
}).$mount('#app');
